import { z } from 'zod'

const UpdateHypothesisSchema = z.object({
  id: z.string(),
  userId: z.string(),
  projectId: z.string(),
  kindId: z.string(),
  hypotheses: z.string(),
  raceId: z.string(),
  toolId: z.string(),
  toolCustom: z.string(),
  answerHypothese: z.string(),
  action: z.string(),
  priorityId: z.string(),
  markId: z.string(),
  markCustom: z.string(),
  markTypeId: z.string(),
  planningResult: z.string(),
  dateRangeStart: z.string(),
  dateRangeEnd: z.string(),
  statusId: z.string(),
  dateStart: z.string(),
  dateEdit: z.string(),
  fact: z.string(),
  conclusions: z.string(),
  hypotheseCustom: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  userFunnelStep: z.string(),
  growthPointId: z.string(),
  isSuccess: z.any().optional(),
  processStatus: z.string(),
  premise: z.string(),
  expectedResult: z.string(),
  script: z.string(),
  hypothesisId: z.string(),
  achievementStatus: z.string(),
})

const UpdateHypothesisDtoSchema = z.object({
  id: z.number(),
  user_id: z.number(),
  project_id: z.number(),
  hypothese_id: z.number(),
  hypotheses: z.string(),
  race_id: z.number(),
  tool_id: z.number(),
  tool_custom: z.string(),
  answer_hypothese: z.string(),
  action: z.string(),
  priority_id: z.number(),
  mark: z.number(),
  mark_custom: z.string(),
  mark_type: z.number(),
  planing_result: z.string(),
  date_range_start: z.string(),
  date_range_end: z.string(),
  status_id: z.number(),
  date_start: z.string(),
  date_edit: z.string(),
  fact: z.string(),
  conclusions: z.string(),
  hypothese_custom: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
  user_funnel_step: z.string(),
  growth_point_id: z.number(),
  is_success: z.string(),
  process_status: z.string(),
  premise: z.string(),
  expected_result: z.string(),
  script: z.string(),
  hypothesis_id: z.number(),
  achievement_status: z.number(),
})

const UpdateHypothesisResponseSchema = UpdateHypothesisDtoSchema

export { UpdateHypothesisDtoSchema, UpdateHypothesisSchema, UpdateHypothesisResponseSchema }
